<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
<!--  HRIS PAGES -->
        <div v-if="$route.meta.roles == 'hr'">
            <!-- <button v-on:click="say('salut')">Dire salut</button> -->
            <sidebar-link to="/hr/dashboard"> 
                <i class="fa fa-home"></i>
                 <p>Dashboard</p>
             </sidebar-link>
             <sidebar-link to="/hr/newemployee"> 
                <i class="fa fa-user-plus"></i>
                 <p>New Employee</p>
             </sidebar-link>
             <sidebar-link to="/hr/employeelist"> 
              <i class="fa fa-address-card"></i>
               <p>Employee Management</p>
           </sidebar-link>
           <sidebar-link to="/hr/absenceleave"> 
            <i class="fa fa-plane"></i>
            <p>Leave Management</p>
          </sidebar-link>
            <sidebar-link to="/hr/payslip"> 
                <i class="fa fa-money"></i>
                <p>Employee Payslip</p>
            </sidebar-link> 
          <sidebar-link to="/hr/performance"> 
            <i class="fa fa-balance-scale"></i>
              <p>Employee Evaluation</p>
           </sidebar-link>
          <sidebar-link to="/hr/jobinformation"> 
              <i class="fa fa-folder-open-o"></i>
               <p>Job Information</p>
           </sidebar-link>
             <sidebar-link to="/hr/contributions/list"> 
              <i class="fa fa-money"></i>
               <p>Loan & Contributions</p>
           </sidebar-link>
             <sidebar-link to="/hr/contactinfo"> 
              <i class="fa fa-phone"></i>
                <p>Contact List</p>
              </sidebar-link>
           
            <sidebar-link to="/hr/requirements"> 
              <i class="fa fa-file-text-o"></i>
                <p>Requirements Tracker</p>
            </sidebar-link>
              <sidebar-link to="/hr/calendar"> 
                <i class="fa fa-calendar"></i>
                <p>Calendar</p>
              </sidebar-link>
         
             <sidebar-link to="/hr/responsibilityform"> 
              <i class="fa fa-edit"></i>
                <p>Responsibility form</p>
            </sidebar-link>
            <sidebar-link to="/hr/department"> 
             <i class="fa fa-sitemap"></i>
               <p>Departments</p>
            </sidebar-link>  
            <sidebar-link to="/hr/position"> 
            <i class="fa fa-address-book-o"></i>
              <p>Designations</p>
            </sidebar-link>
           <!-- 
            <i class="fa fa-address-card-o"></i>
              <p>Employee accounts</p>
           <sidebar-link to="/hr/employeeaccount">   -->
                                                                                                                                                                                                                                                
           <!-- <sidebar-link to="/hr/reports"> 
              <i class="fa fa-bar-chart"></i>
                <p>Reports</p>
           </sidebar-link>  -->
           
           <sidebar-link to="/hr/timeattendance"> 
             <i class="fa fa-clock-o"></i>
              <p>Time & Attendance</p>
           </sidebar-link> 
           <sidebar-link to="/hr/contractsmemo">
            <i class="fa fa-newspaper-o"></i>
             <p>Contracts and Memos</p>
           </sidebar-link>
            <!-- <sidebar-link to="/hr/payroll"> 
                <i class="fa fa-clipboard"></i>
                <p>Payroll Management</p>
            </sidebar-link>  -->
           <!-- <sidebar-link to="/hr/performance"> 
            <i class="fa fa-balance-scale"></i>
              <p>Performance Evaluation</p>
           </sidebar-link> -->

           <sidebar-link to="/hr/users"> 
            <i class="fa fa-users"></i>
              <p>User Management</p>
           </sidebar-link>
           <sidebar-link to="/hr/usersroles"> 
            <i class="fa fa-envira"></i>
              <p>User Roles</p>
           </sidebar-link>
           <sidebar-link to="/hr/settings"> 
              <i class="fa fa-gear"></i>
                <p>Settings</p>
           </sidebar-link> 
           <hr style="background: rgba(255, 255, 255, 0.2);margin-top:4px;margin-bottom: 4px;width: 85%"/> 
           <sidebar-link to="/logout"> 
            <i class="fa fa-sign-out"></i>
              <p>Logout</p>
           </sidebar-link> 
      </div>      
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click="toggleSidebar">
      </dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>

<script>
 /* eslint-disable */
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    mounted:function(){
       
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
    },
    computed:{
      activeMenu(){
        alert(this.$route.name)
      }
    }
  }

</script>
<style>

 .subordinatesSytle{
    /* background-color: rgb(236, 243, 217); */
    height: 300px;
    width: 450px;  
    overflow-y: auto !important;
  }
 .nav-link p {
  font-weight: 200 !important;
  font-size: 14px !important;
  text-transform: none !important;
}

.sidebar .nav li .nav-link,
body>.navbar-collapse .nav li .nav-link {
  color: #FFFFFF;
  margin: 5px 15px;
  /* opacity: .86; */
  border-radius: 4px;
  display: block;
  padding: 6px 7px !important;
}

.sidebar:after,
.sidebar:before,
body>.navbar-collapse:after,
body>.navbar-collapse:before {
  display: none !important;
  content: none !important;
  position: none !important;
  width: none !important;
  height: none !important;
  top: 0 !important;
  left: 0 !important;
  z-index: none !important;
}

.fa-update {
  color: #07b22c;
  font-size: 19px;
}

.bg-breadcrum {
  background: #fff;
}

.alert-info {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}
.image-pic {
   cursor: pointer;
   width: 110px;
   height: 100px;
   margin: 5px;
}
.pending {
  background: #ffc107;
  color: #666;
  border: 0px solid #666;
  padding: 0px 30px 0px 30px;
  cursor:default !important;
}

.approved {
  background: #28a745;
  border: 0px solid #28a745;
  padding: 0px 25px 0px 25px;
  color: #fff;
}

.approved-leave {
  background: #28a745;
  border: 0px solid #28a745;
  padding: 0px 16px 0px 16px;
  color: #fff;
}

.notice-decision{
  border: 1px solid #666;
  border-radius: 0px;
  cursor: default !important;
}
 .border-box-leave{
    border: 1px dashed #666;
    width: 100%;
    padding: 20px;
}

.report-header-decision{
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 38px;
  margin: auto 25%;
}

.rejected {
  background-color: #dc3545;
  border-color: #dc3545;
  border: 0px solid #dc3545;
  padding: 0px 28px 0px 28px;
  color: #fff;
  cursor:default !important;
}

.border-box-undertime {
  border: 1px dashed #666;
  width: 100%;
  padding: 20px;
}

.link-default-leave {
  color: #666;
}

.card label {
  font-size: 16px;
  margin-bottom: 6px;
  text-transform: none;
  color: #666;
}
.p-table{
    background: #edd694;
}

/* The container */

.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.text-fade {
  color: #918d8d;
}

.p-text {
  color: #000;
  font-weight: 400;
}

.text-right {
  float: right;
  margin-top: 7px;
}

.title-section {
  font-size: 18px;
}

.custom-button-width {
  width: 100%;
  margin-right: 2px;
}

.m-right {
  margin: 0px !important;
  padding-right: 0px!important;
}

.r-link {
  color:#1DC7EA !important;
  text-decoration: underline;
}

.action-item-occurence {
  margin-top: -90px;
  position: absolute;
}

.floater-point {
  float: right;
  width: 100px;
  margin-right: -10px;
}

.border-box-nte {
  border: 1px #666 dashed !important;
  padding: 10px!important;
}

.text-right {
  float: right;
  margin-top: 7px;
}

.reason {
  background: #fcffb3;
}


/** 
 * REPORT CSS LAYOUT TEMPLATING 
 */
 .report-signature-container-wfh {
   position: absolute;
   width: 150px;
   height: 90px;
   margin-top: -100px;
   margin-left: 7%;
}
.report-gatter {
  height: 7px;
  background: #969292;
}

.report-container-wfh{
  width: 60%;
  margin: auto;
}
.report-container {
  width: 75%;
  margin: auto;
}

.report-border-wfh {
  border: 1px solid #ebebeb;
  /* box-shadow: 5px 10px #888888; */
  animation: mymove 5s infinite;
  width: 100%;
  padding: 60px;
}
.report-border-full {
  border: 1px solid #666;
  width: 100%;
}
.infraction-border {
   border: 1px dashed #000;
   background: #ffe373;
   padding: 5px;
}
.report-border-right {
  border-right: 1px solid #000;
}

.report-header {
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 38px;
  margin: auto 25%;
}

.report-header-nte {
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 38px;
  margin: auto 30%;
}

.report-border-full-padding {
  border: 1px solid #666;
  width: 100%;
  padding: 18px 18px 5px 5px;
}

.report-line-divider {
  background: #666;
  height: 1px;
  width: 100%;
}

.report-signature-container {
  position: absolute;
  width: 150px;
  height: 90px;
  margin-top: -75px;
  margin-left: 30%;
}

.report-signature-control {
  width: 73.9%;
}

.report-printed-control {
  z-index: 0px;
  margin-top: -60px;
}
  
  </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue